export class Language {
  name: string;
  native: string;
  shortCode: string;
}



// WEBPACK FOOTER //
// ./src/config/i18n/models/language.model.ts